var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.2498C12.1667 16.2498 14.25 14.5832 14.25 14.5832V6.6665M8 16.2498C3.83333 16.2498 1.75 14.5832 1.75 14.5832V6.6665M8 16.2498V19.5832M8 19.5832H3.83333M8 19.5832H12.1667M4.25 3.74984H6.33333M9.66667 3.74984H11.75M4.25 7.08317H6.33333M9.66667 7.08317H11.75M4.25 10.4165H6.33333M9.66667 10.4165H11.75M8 0.416504C6.46833 0.416504 5.21833 0.641504 4.25 0.926504V13.2398C5.21833 13.5248 6.46833 13.7498 8 13.7498C9.53167 13.7498 10.7817 13.5248 11.75 13.2398V0.926504C10.7817 0.641504 9.53167 0.416504 8 0.416504Z",
    stroke: "#3594FF",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.6ed1885495e63e9c92d0e4c88048e8dd.svg";
export { ForwardRef as ReactComponent };